(function($, window) {
  "use strict";

  DSV.ui.bannerNotification = {
    close: function() {
      DSV.ui.cookies.setCookie(this.id, true);
      this.dom.container.parentNode.removeChild(this.dom.container);
    },
    init: function(container) {
      this.dom = {};
      this.dom.container = container;
      this.dom.ctaButton = this.dom.container.querySelector(".cta.cta--module");
      this.dom.closeButton = this.dom.container.querySelector(
        ".banner-notification__close"
      );

      this.id = this.dom.container.getAttribute("id");

      if (this.dom.ctaButton) {
        this.dom.ctaButton.addEventListener(
          "click",
          DSV.ui.bannerNotification.close.bind(this)
        );
      }
      if (this.dom.closeButton) {
        this.dom.closeButton.addEventListener(
          "click",
          DSV.ui.bannerNotification.close.bind(this)
        );
      }
    },
  };
})(jQuery, window);
